import type { IntlShape } from "@formatjs/intl";
import { Col, Form, Input, Row, Select } from "antd";
import { useEffect } from "react";
import { Card } from "../../common/components/Card.tsx";
import type { UserGroup } from "../generated-axios-client/index.ts";

type UserFieldsProps = {
  intl: IntlShape;
  isEdit?: boolean;
  availableGroups: UserGroup[];
};

export const UserFields = ({ intl, availableGroups }: UserFieldsProps) => {
  const form = Form.useFormInstance();
  const selectedGroupId = Form.useWatch("group", form);
  const selectedGroup = availableGroups.find((g) => g.id === selectedGroupId);
  const isTechnician = selectedGroup?.name?.toLowerCase() === "technician";

  useEffect(() => {
    if (!isTechnician) {
      form.setFieldValue("technician_level", null);
    }
  }, [isTechnician, form]);

  return (
    <Card title={intl.formatMessage({ id: "user_section_details" })}>
      <Row gutter={24}>
        {/* <Col xs={24} md={12}>
          <Form.Item
            name="username"
            label={intl.formatMessage({ id: "user_username" })}
            rules={[
              {
                required: true,
                message: intl.formatMessage({ id: "validation_message_user_username" }),
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Col> */}
        <Col xs={24} md={12}>
          <Form.Item
            name="email"
            label={intl.formatMessage({ id: "user_email" })}
            rules={[
              {
                required: true,
                type: "email",
                message: intl.formatMessage({ id: "validation_message_user_email" }),
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col xs={24} md={12}>
          <Form.Item
            name="first_name"
            label={intl.formatMessage({ id: "user_first_name" })}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            name="last_name"
            label={intl.formatMessage({ id: "user_last_name" })}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col xs={24} md={12}>
          <Form.Item
            name="phone_number"
            label={intl.formatMessage({ id: "user_phone_number" })}
            rules={[
              {
                required: true,
                message: intl.formatMessage({
                  id: "validation_message_user_phone_number",
                }),
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item name="group" label={intl.formatMessage({ id: "user_group" })}>
            <Select
              allowClear
              options={availableGroups.map((g) => ({ label: g.name, value: g.id }))}
            />
          </Form.Item>
        </Col>
      </Row>
      {isTechnician && (
        <Row gutter={24}>
          <Col xs={24} md={12}>
            <Form.Item
              name="technician_level"
              label={intl.formatMessage({ id: "user_technician_level" })}
            >
              <Select
                allowClear
                options={[
                  {
                    label: intl.formatMessage({ id: "user_technician_level_l1" }),
                    value: "L1",
                  },
                  {
                    label: intl.formatMessage({ id: "user_technician_level_l2" }),
                    value: "L2",
                  },
                  {
                    label: intl.formatMessage({ id: "user_technician_level_l3" }),
                    value: "L3",
                  },
                ]}
              />
            </Form.Item>
          </Col>
        </Row>
      )}
    </Card>
  );
};
